import type { ThinkingLevel } from "@caupulican/pi-agent-core";

export const DEFAULT_THINKING_LEVEL: ThinkingLevel = "medium";
